import { FormikProps, FormikValues } from "formik";
import { useTranslation } from "next-i18next";
import React from "react";

import ActionButton from "../../../buttons/action-button";
import { KINDS, SIZES } from "../../../buttons/buttons.constants";
import { TYPES } from "../../../inputs/input.constants";
import { TextInput } from "../../../inputs/text-input/text-input";
import styles from "../forms.module.scss";

type Props = {
    formikProps: FormikProps<FormikValues>;
};

const BuyerDetailsForm: React.FC<Props> = ({
    formikProps: {
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        submitForm,
    },
}) => {
    const { t } = useTranslation();
    return (
        <div className={styles.buyerDetailsForm}>
            <form onSubmit={handleSubmit}>
                <TextInput
                    type={TYPES.TEXT}
                    label={t("giftCards.forms.buyForYourself.firstname")}
                    name="firstname"
                    fullWidth={true}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.firstname}
                    touched={touched.firstname}
                    errors={errors.firstname}
                />

                <TextInput
                    type={TYPES.TEXT}
                    label={t("giftCards.forms.buyForYourself.lastname")}
                    name="lastname"
                    fullWidth={true}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.lastname}
                    touched={touched.lastname}
                    errors={errors.lastname}
                />

                <TextInput
                    label={t("giftCards.forms.buyForYourself.email")}
                    type={TYPES.EMAIL}
                    name="email"
                    fullWidth={true}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.email}
                    touched={touched.email && touched.confirmEmail}
                    errors={errors.email}
                />

                <TextInput
                    label={t("giftCards.forms.buyForYourself.confirmEmail")}
                    type={TYPES.EMAIL}
                    name="confirmEmail"
                    fullWidth={true}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.confirmEmail}
                    touched={touched.confirmEmail && touched.email}
                    errors={errors.confirmEmail}
                />
            </form>

            <div className={styles.mobileConfirmButton}>
                <ActionButton
                    disabled={isSubmitting}
                    fluid={true}
                    kind={KINDS.PRIMARY}
                    size={SIZES.LARGE}
                    label={t("giftCards.forms.submit")}
                    onClick={submitForm}
                />
            </div>
        </div>
    );
};

export default BuyerDetailsForm;
